import { Grid } from "@mui/material";
import React from "react";
import InspiraIconFundacion from "../assets/svg/inspira_fundacion.svg";
import { colors } from "../theme/colors";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();

  if (pathname !== "/" && pathname !== "/result") {
    return null;
  }

  return (
    <div
      style={{
        width: "100%",
        margin: "auto",
        marginTop: "0rem",
        backgroundColor: colors.headerbk,
        height: "120px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        container
        spacing={2}
        justifyContent="center"
        textAlign="center"
        sx={{ marginTop: "0rem" }}
      >
        <Grid item sm={12} xs={12}>
          <a
            href="https://www.inspiraairlines.com/"
            style={{ display: "inline-block" }}
          >
            <img
              src={InspiraIconFundacion}
              alt="inpira_fundacion"
              style={{ maxWidth: "100%", cursor: "pointer" }}
            />
          </a>
        </Grid>
      </Grid>
    </div>
  );
}
